import { render, staticRenderFns } from "./TeamplannerPersonCard.vue?vue&type=template&id=40de5702"
import script from "./TeamplannerPersonCard.vue?vue&type=script&lang=js"
export * from "./TeamplannerPersonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports